/* eslint-disable */

/**
 * rem 相关的工具
 * @param {*}
 */
export const remUtil = {
  // 调整窗口或者翻转屏幕事件
  resizeEvent: 'orientationchange' in window ? 'orientationchange' : 'resize',
  // 事件句柄
  handlers: [],
  // 添加设置rem的事件
  addRemHandler: function (designWith) {
    function recalc() {
      const docEl = document.documentElement
      const clientWidth = docEl.clientWidth
      if (!clientWidth) return
      docEl.style.fontSize = 20 * (clientWidth / Number(designWith)) + 'px'
    }

    if (!document.addEventListener) return
    const handler = throttle(recalc, 500)
    remUtil.handlers.push(handler)
    window.addEventListener(remUtil.resizeEvent, handler, false)
    document.addEventListener('DOMContentLoaded', recalc, false)
  },
  // 移除设置rem的事件
  removeRemHandler: function () {
    remUtil.handlers.forEach((handler) => {
      window.removeEventListener(remUtil.resizeEvent, handler)
    })
  },
}

/**
 * 删除html上的行内style
 */
export function removeAttributeOfHtml() {
  const docEl = document.documentElement
  if (!docEl) return
  docEl.removeAttribute('style')
}

/**
 * viewport的宽度是否比某个值大
 * @param {*} width
 */
export function isWider(width) {
  const viewPortSize = getViewportSize()
  if (viewPortSize.width > width) {
    return true
  }
  return false
}

/**
 * 获取viewport的宽高
 */
export function getViewportSize() {
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  }
}

/**
 * 设置样式
 * @param {*} href
 */
export function setLink(className) {
  let heads = document.getElementsByTagName('head')
  let htmlTags = document.getElementsByTagName('html')
  let htmlTag = htmlTags ? htmlTags[0] : null
  htmlTag.setAttribute('class', className)
}

/**
 * 节流函数
 */
export function throttle(action, delay) {
  let timeout = null
  let lastRun = 0
  return function () {
    if (timeout) return
    let elapsed = Date.now() - lastRun
    let context = this
    let args = arguments
    let runCallback = function () {
      lastRun = Date.now()
      timeout = false
      action.apply(context, args)
    }
    if (elapsed >= delay) {
      runCallback()
    } else {
      timeout = setTimeout(runCallback, delay)
    }
  }
}

export function system() { // 判断并返回系统
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // var isWx = u.indexOf('micromessenger') > -1 // wexin
  var system
  if (isAndroid) {
    system = 'android'
  } else if (isIOS) {
    system = 'ios'
  }
  return system
}

export const downApp = function (appSource) {
  let sys = system()
  if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
    // window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.versa'
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.versa&ckey=CK1434036581524'
  } else if (sys === 'android') {
    // if (appSource && (typeof appSource === 'string') && appSource.length > 0) {
      window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.versa`
    // } else {
      // var u = navigator.userAgent
      // var isAndroid = u.indexOf('weixin') > -1 || u.indexOf('Linux') > -1 // android

        // window.location.href = 'https://static01.versa-ai.com/upload/8ad5d162f488/987a62c0-68dc-4a79-b281-b8618878745c.apk'
      // }


    // }
  } else if (appSource === 'baidupz') {
    window.location.href = 'https://apps.apple.com/app/apple-store/id1214783848?pt=118589366&ct=baidupz&mt=8'
  } else if (appSource === 'douyinkol1') {
    window.location.href = 'https://apps.apple.com/app/apple-store/id1214783848?pt=118589366&ct=douyinkol1&mt=8'
  } else if (appSource === 'douyinkol2') {
    window.location.href = 'https://apps.apple.com/app/apple-store/id1214783848?pt=118589366&ct=douyinkol2&mt=8'
  } else {
    // window.location.href = 'https://itunes.apple.com/us/app/versa/id1214783848?l=zh&ls=1&mt=8'
    window.location.href = 'https://apps.apple.com/app/apple-store/id1214783848?pt=118589366&ct=web&mt=8'
    console.log(`https://apps.apple.com/app/apple-store/id1214783848?pt=118589366&ct=web&mt=8`)
  }
}

export function isIphoneX() {
  return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
}

export function getQueryObj() {
  let url = location.search
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    var strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

export function isEmail(str) {
  var myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org|io)$/
  if (myReg.test(str)) {
    return true
  } else {
    return false
  }
}

export function isTelphone(tel) {
  var reg = /(^1[3|4|5|7|8][0-9]{9}$)/
  if (reg.test(tel)) {
    return true
  } else {
    return false
  }
}
